import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0495 1C13.8768 0.999992 15.3162 0.999985 16.4701 1.10456C17.6481 1.21133 18.6263 1.43338 19.5 1.93782C20.5641 2.5522 21.4478 3.43587 22.0622 4.5C22.5666 5.37372 22.7887 6.35191 22.8954 7.52993C23 8.68378 23 10.1233 23 11.9505V12.0496C23 13.8768 23 15.3162 22.8954 16.4701C22.7887 17.6481 22.5666 18.6263 22.0622 19.5C21.4478 20.5641 20.5641 21.4478 19.5 22.0622C18.6263 22.5666 17.6481 22.7887 16.4701 22.8954C15.3162 23 13.8767 23 12.0495 23H11.9504C10.1232 23 8.68378 23 7.52993 22.8954C6.35191 22.7887 5.37372 22.5666 4.5 22.0622C3.43587 21.4478 2.5522 20.5641 1.93782 19.5C1.43338 18.6263 1.21133 17.6481 1.10456 16.4701C0.999985 15.3162 0.999992 13.8768 1 12.0495V11.9505C0.999992 10.1232 0.999985 8.68379 1.10456 7.52993C1.21133 6.35191 1.43338 5.37372 1.93782 4.5C2.5522 3.43587 3.43587 2.5522 4.5 1.93782C5.37372 1.43338 6.35191 1.21133 7.52993 1.10456C8.68379 0.999985 10.1232 0.999992 11.9505 1H12.0495ZM18.25 4.75C17.6977 4.75 17.25 5.19772 17.25 5.75V5.75391C17.25 6.30619 17.6977 6.75391 18.25 6.75391H18.2539C18.8062 6.75391 19.2539 6.30619 19.2539 5.75391V5.75C19.2539 5.19772 18.8062 4.75 18.2539 4.75H18.25ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6Z"}}]};

const LogoInstagramFilled = Vue.extend<IconProps>({
  name: 'LogoInstagramFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-instagram-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoInstagramFilled;
